import { Box } from "@mui/material";
import {
  type BannerName,
  type BannerProps,
  BANNERS,
} from "@src/appV2/redesign/Accounts/Banners/AccountPageBanner";
import { HorizontalScrollView } from "@src/appV2/redesign/system/ui-components";

interface AccountPageBannersContainerProps {
  workerId: string;
  bannersToSkip?: BannerName[];
}

export function AccountPageBannersContainer(props: AccountPageBannersContainerProps) {
  const { workerId, bannersToSkip = [] } = props;

  const bannerProps: BannerProps = {
    workerId,
    bannersToSkip,
  };

  return (
    <Box sx={{ paddingBottom: 4, marginX: -5 }}>
      <HorizontalScrollView
        stretch
        sx={{
          px: 5,
        }}
      >
        {BANNERS.map((Banner) => (
          <Banner key={Banner.name} {...bannerProps} />
        ))}
      </HorizontalScrollView>
    </Box>
  );
}
